export const hasSessionFOMOD = (stateSession) => "fomod" in stateSession;
export const hasSessionPlugins = (stateSession) => "plugins" in stateSession;
export const hasLoadOrder = (state) => "loadOrder" in state;
